export default "__VITE_ASSET__CS6_A51I__"